// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"bac9b40c","278":"4c05ffb8","354":"96c4cb78","561":"e6d97e4e","680":"88c67c1f","715":"e0a1e6d1","725":"affe5142","857":"7a3b2a15","959":"dad59b8b","973":"07745120"}[chunkId] + ".chunk.js";
};